// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#selectMSA{position:fixed;width:600px;background:#77b07f;left:0;right:0;top:30%;margin:0 auto}#selectMSA #selection .option{float:left;text-align:center;width:200px;height:30px;margin-top:5px}#selectMSA #selection .option .function_button{margin:auto;font-size:20px;color:#fff;background:#77b07f;border:0}#selectMSA #selection .option .function_button:hover{color:#333a61}", ""]);
// Exports
module.exports = exports;
